import { Card, css, MAGNETIC_TOKENS } from '@appd/uik';

const {
  TYPOGRAPHY: { P1_BOLD, P4_EMPHASIS },
} = MAGNETIC_TOKENS;

type Props = {
  title: string;
  value: string;
  className?: string;
};

export function BusinessJourneyStatusCard({ title, value, className }: Props): JSX.Element {
  return (
    <Card.Well className={css({ display: 'flex', flexDirection: 'column', borderRadius: '6px' }, className)}>
      <div className={css({ font: P1_BOLD })}>{value}</div>
      <div className={css({ font: P4_EMPHASIS })}>{title}</div>
    </Card.Well>
  );
}
